import styled from 'styled-components';

export const Container = styled.object`

.settings {
  margin-top:3%;
  margin-right:3%;
  font-size: 14px;
  }
`;